/* es6-symbol/index.js */ function _(require, module, exports) {
    module.exports = require(25) /* ./is-implemented */()
        ? require(26) /* es5-ext/global */.Symbol
        : require(27) /* ./polyfill */;
}
